import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { ConcurrencyResponse, GetAnalyticsDto } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getConcurrency = async ({
  from,
  to,
  organisationId,
}: GetAnalyticsDto) => {
  const response = await axiosClient.get<ConcurrencyResponse>(
    `/analytics/concurrency`,
    {
      params: { from, to, organisationId },
    },
  );

  return response.data;
};

export function useGetConcurrency(
  { from, to, organisationId }: GetAnalyticsDto,
  queryOptions?: Partial<UseQueryOptions<ConcurrencyResponse, HttpError>>,
) {
  return useQuery({
    queryKey: ["analytics", "concurrency", from, to, organisationId],
    queryFn: () => getConcurrency({ from, to, organisationId }),
    ...queryOptions,
  });
}
